import { render, staticRenderFns } from "./AccountData.vue?vue&type=template&id=de0af8de&scoped=true"
import script from "./AccountData.vue?vue&type=script&lang=js"
export * from "./AccountData.vue?vue&type=script&lang=js"
import style0 from "./AccountData.vue?vue&type=style&index=0&id=de0af8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0af8de",
  null
  
)

export default component.exports